// AUTO-GENERATED — DO NOT EDIT MANUALLY
//
// To manage switches, use the generate-feature-switch scripts:
//   pnpm --filter @web-monorepo/feature-switches generate-feature-switch:add --name <name>
//   pnpm --filter @web-monorepo/feature-switches generate-feature-switch:remove --name <name>
//   pnpm --filter @web-monorepo/feature-switches generate-feature-switch:sync

export const FeatureSwitchRegistry = {
  api_marketplace_tutor_auto_messages: {
    _id: "6ac58de07605056f682314ba",
    name: "api_marketplace_tutor_auto_messages",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  api_marketplace_tutor_set_prices: {
    _id: "6a394a012602690ef5a5b002",
    name: "api_marketplace_tutor_set_prices",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  api_semantic_search_enabled: {
    _id: "69fb755bbf5e2a089afa707f",
    name: "api_semantic_search_enabled",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  holdout_growth_teacher_international_2026: {
    _id: "6940ad29b6585ad5c21cd708",
    name: "holdout_growth_teacher_international_2026",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_growth_teacher_notification_2026: {
    _id: "698264f689ab0bd2d9fb4d3a",
    name: "holdout_growth_teacher_notification_2026",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_growth_teacher_sidekick_live_2026: {
    _id: "69d01e22f6a73cbbe87ef044",
    name: "holdout_growth_teacher_sidekick_live_2026",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_parent_plus_revenue_2026: {
    _id: "69436817c81d5caf8754cf9b",
    name: "holdout_parent_plus_revenue_2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_parent_plus_revenue_sept_2026: {
    _id: "6aad8f552be4e0d2e5108fda",
    name: "holdout_parent_plus_revenue_sept_2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_parent_revenue_2026: {
    _id: "6940615fd134f8ed87772785",
    name: "holdout_parent_revenue_2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  holdout_school_leader_activation: {
    _id: "6a274ac415802f7f5de648bc",
    name: "holdout_school_leader_activation",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["baseline", "off", "shipped_improvements"],
    defaultValue: "off",
  },
  monsterverseGraduationPartyClass: {
    _id: "69f125266c5482daad36e957",
    name: "monsterverseGraduationPartyClass",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  monsterverseGraduationPartyMentors: {
    _id: "6a033e482c5aa6aa55871213",
    name: "monsterverseGraduationPartyMentors",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  monsterverseGraduationPartySchoolLaunch: {
    _id: "69fa44e386f7cdfdd63de467",
    name: "monsterverseGraduationPartySchoolLaunch",
    type: "multivariate",
    audienceTypes: ["school", "teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test", "test2"],
    defaultValue: "off",
  },
  monsterverseSplitAvatars: {
    _id: "6aa85d266207271b51b04d65",
    name: "monsterverseSplitAvatars",
    type: "multivariate",
    audienceTypes: ["student"],
    apps: ["student"],
    variants: ["control", "off", "test"],
    defaultValue: "control",
  },
  redirect_parent_login_home_v2: {
    _id: "65cd9002374b6ffeff27d5cf",
    name: "redirect_parent_login_home_v2",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  teacher_invite_whatsapp_brazil: {
    _id: "6ad13abf3a301d873967870d",
    name: "teacher_invite_whatsapp_brazil",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  teacher_magic_assistant_rollout_v2: {
    _id: "6647aeefc864f742230a25fd",
    name: "teacher_magic_assistant_rollout_v2",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_android_login_install_banner_v2: {
    _id: "6a84543c4b0ea254badd9d27",
    name: "web_android_login_install_banner_v2",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_android_signup_install_banner: {
    _id: "6a7da042becb41ab9b38924b",
    name: "web_android_signup_install_banner",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_async_mass_message: {
    _id: "6a836e4cb7bf878f6b2b4041",
    name: "web_async_mass_message",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_dl_message_review: {
    _id: "6a221c07d9b6e17c087181c7",
    name: "web_dl_message_review",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_dojoMath_priceTesting_august2026_v2: {
    _id: "6aa966a13619e8cc0b23dd08",
    name: "web_dojoMath_priceTesting_august2026_v2",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "hundred", "off", "sixty"],
    defaultValue: "off",
  },
  web_dojoMath_priceTesting_august2026_v3: {
    _id: "6ab1b9d99b00dc942c693f20",
    name: "web_dojoMath_priceTesting_august2026_v3",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "hundred", "off", "sixty"],
    defaultValue: "off",
  },
  web_elevated_student_sso: {
    _id: "68c1e7665a9b595db5460d94",
    name: "web_elevated_student_sso",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["student", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_extendedTrial_June_2025: {
    _id: "683dd8a49234dddd3a6a40a2",
    name: "web_extendedTrial_June_2025",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["14day", "30day", "control", "off"],
    defaultValue: "off",
  },
  web_flo_quiz_funnel_v4: {
    _id: "6aa42f2a06696acb645b5df4",
    name: "web_flo_quiz_funnel_v4",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_home_asset_retry_service_worker: {
    _id: "6a96e703afa546130069db8a",
    name: "web_home_asset_retry_service_worker",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_home_design_tokens_v2: {
    _id: "69b461d1f5355390ba93a1e6",
    name: "web_home_design_tokens_v2",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_home_normalize_typography_padding_margin: {
    _id: "6920cb719f2467e3a5864ee6",
    name: "web_home_normalize_typography_padding_margin",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_home_password_complexity: {
    _id: "65258cf4e347dd5585db611f",
    name: "web_home_password_complexity",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_home_tagging_class_story: {
    _id: "68f7ea63f32ddf548a5a59d0",
    name: "web_home_tagging_class_story",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_journey_sparks_test_mode: {
    _id: "692582384dbebbda0f168b75",
    name: "web_journey_sparks_test_mode",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_1_1_Funnel_On_Group_Class_PDP_v1: {
    _id: "6a8dd411ebb3496086a1c718",
    name: "web_marketplace_1_1_Funnel_On_Group_Class_PDP_v1",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_automatic_click_logging: {
    _id: "6a99f6369c46ab175464afbd",
    name: "web_marketplace_automatic_click_logging",
    type: "boolean",
    audienceTypes: ["parent", "teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_automatically_cancel_sections_on_conflict: {
    _id: "6a29cf01a26eff611c191fa6",
    name: "web_marketplace_automatically_cancel_sections_on_conflict",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_blueshift_simplified_funnel_V2: {
    _id: "6a3ad1dd4954d76dfbe39fff",
    name: "web_marketplace_blueshift_simplified_funnel_V2",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_course_video_parents: {
    _id: "6a05d87129b4f73fe14a4088",
    name: "web_marketplace_course_video_parents",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_course_video_search_pdp: {
    _id: "6a05dd0775dabdf63c2fa7a6",
    name: "web_marketplace_course_video_search_pdp",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_course_video_tutors: {
    _id: "6a05d74429b4f73fe14a4087",
    name: "web_marketplace_course_video_tutors",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_decagon_for_parents: {
    _id: "699d8df7bc215b8414404e07",
    name: "web_marketplace_decagon_for_parents",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_decagon_for_tutors: {
    _id: "6961566356c1e0e65ffe8fbb",
    name: "web_marketplace_decagon_for_tutors",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_ed_consultant_reachouts: {
    _id: "689f72e67b70defc1f79984b",
    name: "web_marketplace_ed_consultant_reachouts",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "holdout", "off"],
    defaultValue: "off",
  },
  web_marketplace_enable_last_minute_subs: {
    _id: "68d297692d7d13ecdbc61f5b",
    name: "web_marketplace_enable_last_minute_subs",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_existing_subscription_recovery: {
    _id: "6aa8329de1d4404d9ab151a0",
    name: "web_marketplace_existing_subscription_recovery",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_expand_trial_slots: {
    _id: "6a458fc0b09711192cc80015",
    name: "web_marketplace_expand_trial_slots",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_groupclass_crosssell_tutorsearch_Apr2026: {
    _id: "69da6fdcb6daa70dcefca3de",
    name: "web_marketplace_groupclass_crosssell_tutorsearch_Apr2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_groupclass_homepagelink: {
    _id: "69de6dba28a03276c9f2718e",
    name: "web_marketplace_groupclass_homepagelink",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_groupclass_internal_review: {
    _id: "69e657859fa9475e9c910f76",
    name: "web_marketplace_groupclass_internal_review",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_groupclass_invitefriends_Apr2026: {
    _id: "69e913d32b4af4e45fb06247",
    name: "web_marketplace_groupclass_invitefriends_Apr2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_groupclass_student_transfers: {
    _id: "6ac93c0666eba94e789eba04",
    name: "web_marketplace_groupclass_student_transfers",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_home_parent_chats: {
    _id: "6a5837adf243743b357a3937",
    name: "web_marketplace_home_parent_chats",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_homepage_redesign_sep2026_2: {
    _id: "6a9993328b8180aa661e1714",
    name: "web_marketplace_homepage_redesign_sep2026_2",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_last_minute_pubnub_sept2025: {
    _id: "68d2ebec7260884dd3189fb6",
    name: "web_marketplace_last_minute_pubnub_sept2025",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_last_minute_sub_sept2025: {
    _id: "68bf2240036655dafcc2f0d9",
    name: "web_marketplace_last_minute_sub_sept2025",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_longer_class_dashboard_upsells: {
    _id: "68c093a601de48185bd1c5ef",
    name: "web_marketplace_longer_class_dashboard_upsells",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_lp_simplified_funnel: {
    _id: "6a24f98ea585222195a8f2c2",
    name: "web_marketplace_lp_simplified_funnel",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_normalize_typography_padding_margin: {
    _id: "6920cb759f2467e3a5864ee8",
    name: "web_marketplace_normalize_typography_padding_margin",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_billing: {
    _id: "69e77b0837ac034ea81beba5",
    name: "web_marketplace_parent_billing",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_campaign_banner: {
    _id: "6972732cbaf72722d64ea2d1",
    name: "web_marketplace_parent_campaign_banner",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_chats: {
    _id: "6a04fdc259fa4dce156a28a0",
    name: "web_marketplace_parent_chats",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_language_settings: {
    _id: "6ab330a0b671569c62881766",
    name: "web_marketplace_parent_language_settings",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_realtime_transcription: {
    _id: "6a38326da7e0f13ecf4570a1",
    name: "web_marketplace_parent_realtime_transcription",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_parent_referral_pdp_sharing: {
    _id: "6a57f6e7c703c719d4f5999d",
    name: "web_marketplace_parent_referral_pdp_sharing",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_referrals_entrypoints: {
    _id: "69f2714a5bd80454ed585d52",
    name: "web_marketplace_parent_referrals_entrypoints",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_parent_section_start_date: {
    _id: "6a075cfb7cb573648dd2f837",
    name: "web_marketplace_parent_section_start_date",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_parent_send_message_tutor_pdp: {
    _id: "6a86254a14a347791c5dae4e",
    name: "web_marketplace_parent_send_message_tutor_pdp",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_parent_send_message_tutor_search: {
    _id: "6a8f3d75c5422244278a3019",
    name: "web_marketplace_parent_send_message_tutor_search",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_parent_tsp_checkout_breakdown_aug2026: {
    _id: "6a7c5c38cd1bf2ff1dd78197",
    name: "web_marketplace_parent_tsp_checkout_breakdown_aug2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_referrals_postcheckout_May2026: {
    _id: "69f90ba7de13c21faf46491c",
    name: "web_marketplace_referrals_postcheckout_May2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_search_additional_class_oct2025_v2: {
    _id: "68efed946250943ab4a6f1b4",
    name: "web_marketplace_search_additional_class_oct2025_v2",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_show_diagnostic_link: {
    _id: "693c8599befbe9ab9f936952",
    name: "web_marketplace_show_diagnostic_link",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_show_messaging_link_warning_sept_2025: {
    _id: "6ab558fe6f3bff9c0dcaec36",
    name: "web_marketplace_show_messaging_link_warning_sept_2025",
    type: "multivariate",
    audienceTypes: ["parent", "teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_show_pdp_buttons_in_profile_editor_nov2025: {
    _id: "6925fa391426a92b6e6e7101",
    name: "web_marketplace_show_pdp_buttons_in_profile_editor_nov2025",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_show_prices_tutor_search_aug2026: {
    _id: "6a79cfda80902d6e0d13aefa",
    name: "web_marketplace_show_prices_tutor_search_aug2026",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_show_prices_tutor_search_august_2027: {
    _id: "6a763e063e1d49d4c0ce5135",
    name: "web_marketplace_show_prices_tutor_search_august_2027",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_subscription_outcome_value_priming_v2: {
    _id: "6abc1baaced069515a16b1bd",
    name: "web_marketplace_subscription_outcome_value_priming_v2",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_trial_decline_2026: {
    _id: "6a389d131d59a7704ea68b32",
    name: "web_marketplace_trial_decline_2026",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_trial_flo_v1: {
    _id: "6a5f6ea8eb6b8637fd0cd4ec",
    name: "web_marketplace_trial_flo_v1",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_tutor_campaign_banner: {
    _id: "69727312baf72722d64ea2cc",
    name: "web_marketplace_tutor_campaign_banner",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_chats: {
    _id: "6a04fdd359fa4dce156a28a1",
    name: "web_marketplace_tutor_chats",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_community: {
    _id: "6abbd9d898fbc462ec66c366",
    name: "web_marketplace_tutor_community",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_course_thumbnail_generator: {
    _id: "6a4fe6a7d04a3f501e6b8378",
    name: "web_marketplace_tutor_course_thumbnail_generator",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_design_tokens_v2: {
    _id: "69b4620ef5355390ba93a1e8",
    name: "web_marketplace_tutor_design_tokens_v2",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_freq_rec_v2: {
    _id: "6aa077d3d6734ce73c0ba005",
    name: "web_marketplace_tutor_freq_rec_v2",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_tutor_payouts: {
    _id: "69c3e36d636623c407cd0669",
    name: "web_marketplace_tutor_payouts",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_realtime_transcription: {
    _id: "6a383208c3987b64c9f4f540",
    name: "web_marketplace_tutor_realtime_transcription",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_tutor_review_responses: {
    _id: "6982a15de57c540b2d04d9ac",
    name: "web_marketplace_tutor_review_responses",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_tutor_section_start_date: {
    _id: "6a0732dd2aa98c51be01eb70",
    name: "web_marketplace_tutor_section_start_date",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_marketplace_tutor_substitute_toggle: {
    _id: "69f3bfd808ab0f7e0a681ef5",
    name: "web_marketplace_tutor_substitute_toggle",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_marketplace_yearly_recap: {
    _id: "69434572523888353a793e29",
    name: "web_marketplace_yearly_recap",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_mass_messaging_stateful: {
    _id: "6a9854e8dca53a94cd7a7eba",
    name: "web_mass_messaging_stateful",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_messaging_reactions: {
    _id: "69cac58e525b71f2cfabb2df",
    name: "web_messaging_reactions",
    type: "boolean",
    audienceTypes: ["parent", "student", "teacher"],
    apps: ["home", "marketplace", "student", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_messaging_reactions_by_school: {
    _id: "6ab2b3426539797f1104c3c7",
    name: "web_messaging_reactions_by_school",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["home", "student", "teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_nats_exhausted_poll: {
    _id: "6a4f89eed12a93f55794bf6a",
    name: "web_nats_exhausted_poll",
    type: "boolean",
    audienceTypes: ["parent", "student", "teacher"],
    apps: ["home", "student", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_nats_exhausted_state_machine: {
    _id: "6a4f89c42b2d4fde6116d3c5",
    name: "web_nats_exhausted_state_machine",
    type: "boolean",
    audienceTypes: ["parent", "student", "teacher"],
    apps: ["home", "student", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_nats_optimistic_updates: {
    _id: "69f8e1bbd05858031dac7df2",
    name: "web_nats_optimistic_updates",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["student", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_parent_coparent_invite_improvements: {
    _id: "6a0e2ac5c25cd8c426b1fd60",
    name: "web_parent_coparent_invite_improvements",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_parent_onboarding_quiz_flow_gate: {
    _id: "6a85a0ce7a5283fd8f521698",
    name: "web_parent_onboarding_quiz_flow_gate",
    type: "boolean",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_parent_reports_upsell: {
    _id: "6941a77eab883cddbc25f743",
    name: "web_parent_reports_upsell",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_parent_signupcontainer_refactor_v5: {
    _id: "67102ccfc9f4bbb714fa63a1",
    name: "web_parent_signupcontainer_refactor_v5",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_parent_verify_hashed_users_holdout: {
    _id: "661072c76f490a8a47dd01e4",
    name: "web_parent_verify_hashed_users_holdout",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_payout_show_future_sessions: {
    _id: "6a737cfbe0a775abf271b0b1",
    name: "web_payout_show_future_sessions",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["marketplace"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_pcr_email_required_enabled: {
    _id: "66b19e5c8fa832f02727b1e4",
    name: "web_pcr_email_required_enabled",
    type: "boolean",
    audienceTypes: ["parent", "teacher"],
    apps: ["home", "teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_promo_audit_provider_logging: {
    _id: "6a1f24bddde28540d0352b8c",
    name: "web_promo_audit_provider_logging",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_school_leader_bulk_resend_parent_invites_experiment: {
    _id: "6a7a6194dca5e665e3d2f420",
    name: "web_school_leader_bulk_resend_parent_invites_experiment",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_school_leader_calendly_embed_v2: {
    _id: "6a67ed85c7fe6ce459166f75",
    name: "web_school_leader_calendly_embed_v2",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_school_leader_message_export: {
    _id: "6983c5da481d96aeca2610ab",
    name: "web_school_leader_message_export",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_school_leader_message_logs: {
    _id: "69821157b392270551340c2f",
    name: "web_school_leader_message_logs",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_school_leader_message_review: {
    _id: "693a40be58ee9ca10c6cb6a7",
    name: "web_school_leader_message_review",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_school_leader_verification_copy: {
    _id: "6a61802e0d86324f233bb888",
    name: "web_school_leader_verification_copy",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_school_shutdown_family_chats: {
    _id: "685ef3b096299b9244609b9d",
    name: "web_school_shutdown_family_chats",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_stripe_trial_eligibility: {
    _id: "69d6959e7edc92fc13a3d932",
    name: "web_stripe_trial_eligibility",
    type: "multivariate",
    audienceTypes: ["parent"],
    apps: ["home"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_student_design_tokens_v2: {
    _id: "69b461eef5355390ba93a1e7",
    name: "web_student_design_tokens_v2",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["student"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_student_normalize_typography_padding_margin: {
    _id: "6920cb739f2467e3a5864ee7",
    name: "web_student_normalize_typography_padding_margin",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["student"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_student_unified_google_auth_logged_out: {
    _id: "69a7082783bee522160f834f",
    name: "web_student_unified_google_auth_logged_out",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["student"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_student_unified_google_auth_logged_out_v2: {
    _id: "69cbe81ccff612d81ce789a5",
    name: "web_student_unified_google_auth_logged_out_v2",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["student"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_student_unified_google_auth_logged_out_v3: {
    _id: "69d568fec2a85a3847775371",
    name: "web_student_unified_google_auth_logged_out_v3",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["student"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_active_schoolwide_sls: {
    _id: "686eeb4ed6eccd6c70e9b908",
    name: "web_teach_active_schoolwide_sls",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_active_sls_eligible_1on1s_bts2025: {
    _id: "686eeca5cb4b2b83b50e9804",
    name: "web_teach_active_sls_eligible_1on1s_bts2025",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_archive_and_delete_directory_actions: {
    _id: "6879df758623ceabb843ca7c",
    name: "web_teach_archive_and_delete_directory_actions",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_asset_retry_service_worker: {
    _id: "6a96e712afa546130069db8b",
    name: "web_teach_asset_retry_service_worker",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_awards_valtio_store: {
    _id: "6a29972f5db74984aa35cc5b",
    name: "web_teach_awards_valtio_store",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_become_mentor_march2025_audience: {
    _id: "67e2c313161f10eed6b45ddc",
    name: "web_teach_become_mentor_march2025_audience",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_bts_2024_campaigns_holdout: {
    _id: "66a94389bfebd2b0d87b9457",
    name: "web_teach_bts_2024_campaigns_holdout",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "holdout", "off"],
    defaultValue: "off",
  },
  web_teach_bts_2026_holdout: {
    _id: "6a5015f220d38129ef289e7d",
    name: "web_teach_bts_2026_holdout",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["holdout", "off", "rollout", "test"],
    defaultValue: "off",
  },
  web_teach_bts_night_2026_modal: {
    _id: "6a7102ea5af41235f441b7bc",
    name: "web_teach_bts_night_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_bulk_class_upload_opt_out: {
    _id: "6892287f18c27f6475824ebb",
    name: "web_teach_bulk_class_upload_opt_out",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_calendar_bulk_upload: {
    _id: "6aa2e14275ecbf9a6128c092",
    name: "web_teach_calendar_bulk_upload",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_calendar_month_view: {
    _id: "6a975f3bb4e066e68926ac12",
    name: "web_teach_calendar_month_view",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test_month_default", "test_schedule_default"],
    defaultValue: "control",
  },
  web_teach_canva_story_modal: {
    _id: "69a644a702043e0338f2a47b",
    name: "web_teach_canva_story_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_class_linking: {
    _id: "6ac5323f678853a2b5cd89be",
    name: "web_teach_class_linking",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_class_linking_settings: {
    _id: "6ac534fa678853a2b5cd89c7",
    name: "web_teach_class_linking_settings",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_community_team_holdout_2025_2026: {
    _id: "693b2a8daa4c89cc5f1a90a7",
    name: "web_teach_community_team_holdout_2025_2026",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_community_team_holdout_mentors_2026_2027: {
    _id: "6ac801d50fcc40ec94ed51ce",
    name: "web_teach_community_team_holdout_mentors_2026_2027",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_design_tokens_v2: {
    _id: "69b461a1f5355390ba93a1e5",
    name: "web_teach_design_tokens_v2",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_district_announcement_ai_compose: {
    _id: "69fa0197393f966b578ca9e2",
    name: "web_teach_district_announcement_ai_compose",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_district_attendance_individual_alerts: {
    _id: "691fc4f0ac8510a16d174b01",
    name: "web_teach_district_attendance_individual_alerts",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_district_attendance_tardy_settings: {
    _id: "691e3ce5e4cf17d3fa1e02c1",
    name: "web_teach_district_attendance_tardy_settings",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_district_feed: {
    _id: "69ef86afcf09c77e4b3a724d",
    name: "web_teach_district_feed",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_districts_hub_community_audience_modal: {
    _id: "693b1c41231a0e567e0ea440",
    name: "web_teach_districts_hub_community_audience_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_empty_state_families_v2: {
    _id: "6ac95b97c4fb08fc0cf7e0f0",
    name: "web_teach_empty_state_families_v2",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_enable_sl_eligibility_logging: {
    _id: "689a0913ac061c9d85be58f0",
    name: "web_teach_enable_sl_eligibility_logging",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_event_posting_options: {
    _id: "6abed2f46ffac48b2b073cf3",
    name: "web_teach_event_posting_options",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "control",
  },
  web_teach_evergreen_schoolwide_2026_modal_by_school: {
    _id: "69ea8b8d636a0e72ed868431",
    name: "web_teach_evergreen_schoolwide_2026_modal_by_school",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["holdout", "off", "rollout", "test"],
    defaultValue: "off",
  },
  web_teach_full_screen_add_students_v3: {
    _id: "6ab17191afa1822ca0687144",
    name: "web_teach_full_screen_add_students_v3",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_full_screen_on_rails_add_class_v3: {
    _id: "6aba9bc6942f8bd375fc5cd1",
    name: "web_teach_full_screen_on_rails_add_class_v3",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_hs_checklist_prio_v3: {
    _id: "6ac7c9ce5af2f12932371718",
    name: "web_teach_hs_checklist_prio_v3",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_invite_little_kid_to_elevate: {
    _id: "69de81aae3ed59ba09cf18f4",
    name: "web_teach_invite_little_kid_to_elevate",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_invite_school_leader_ab_modal: {
    _id: "69b31d7e191d6efe36066499",
    name: "web_teach_invite_school_leader_ab_modal",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_invite_scoped_sso: {
    _id: "6ac3d1a505c3a0b526050f11",
    name: "web_teach_invite_scoped_sso",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_invite_signup_hide_sso: {
    _id: "6a6b8d9273102b7768db5dcf",
    name: "web_teach_invite_signup_hide_sso",
    type: "boolean",
    audienceTypes: ["session"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_islands_bts_2026_holdout: {
    _id: "6a907f3e189423e3d1a1c97a",
    name: "web_teach_islands_bts_2026_holdout",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_islands_bts_2026_modal_1: {
    _id: "6a8dfaf98c0e0d88d0036033",
    name: "web_teach_islands_bts_2026_modal_1",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_islands_bts_2026_modal_2: {
    _id: "6a8dfb5d9d4ffcf0f69cc6cb",
    name: "web_teach_islands_bts_2026_modal_2",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_islands_spooky_2026_modal_1: {
    _id: "6ac39dd3d22014ba448c9f61",
    name: "web_teach_islands_spooky_2026_modal_1",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_land_on_chats_tab: {
    _id: "6aa846646b077acf9b2f07fb",
    name: "web_teach_land_on_chats_tab",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "control",
  },
  web_teach_list_schools_to_hide_1on1_box_2025: {
    _id: "682fc184c4579b22e948461f",
    name: "web_teach_list_schools_to_hide_1on1_box_2025",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_marketplace_tutors_on_classroom_tab: {
    _id: "696822e71ed797c54df369c0",
    name: "web_teach_marketplace_tutors_on_classroom_tab",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_may_challenge_2026_modal: {
    _id: "6a027750c98cef1056314e98",
    name: "web_teach_may_challenge_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_mentor_bts_event_2026_modal: {
    _id: "6a836b66ee927f1927b33d02",
    name: "web_teach_mentor_bts_event_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_mentor_clark_2026_modal: {
    _id: "6a986eab97892a9f2e813d2c",
    name: "web_teach_mentor_clark_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_mentor_kit_survey_2026_modal: {
    _id: "6aa31221a9002c5e5924f38b",
    name: "web_teach_mentor_kit_survey_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_mentor_recruitment_feb2026: {
    _id: "6985460b8e5f3e6bf47af1dd",
    name: "web_teach_mentor_recruitment_feb2026",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_modal_t1_bts_2026: {
    _id: "6a70bd6461b662c8d94b5852",
    name: "web_teach_modal_t1_bts_2026",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_more_for_mentors_canva_certificate_modal: {
    _id: "69d84983380bab8080e59269",
    name: "web_teach_more_for_mentors_canva_certificate_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_more_for_mentors_epic_2026_modal: {
    _id: "6aab34a1f192e4aff574de44",
    name: "web_teach_more_for_mentors_epic_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_more_for_mentors_follow_up_modal: {
    _id: "6a18cd1a85926dbdb93309c2",
    name: "web_teach_more_for_mentors_follow_up_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_more_for_mentors_may_2026_modal: {
    _id: "69f3602a9ee80db1a7a0f91f",
    name: "web_teach_more_for_mentors_may_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_multi_class_story_post: {
    _id: "69aa3d2341a668bcbfc35330",
    name: "web_teach_multi_class_story_post",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_new_attendance_home: {
    _id: "6ab5671dcbc2975e7342d250",
    name: "web_teach_new_attendance_home",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_new_points_report_notes: {
    _id: "69f222a635111203a2b27bc2",
    name: "web_teach_new_points_report_notes",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_new_school_admin_nux_v2: {
    _id: "6a4e741736bf05749e09cc56",
    name: "web_teach_new_school_admin_nux_v2",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_normalize_typography_padding_margin: {
    _id: "6920cb6f9f2467e3a5864ee5",
    name: "web_teach_normalize_typography_padding_margin",
    type: "boolean",
    audienceTypes: ["session", "teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_october_mentor_lounge_2026_modal: {
    _id: "6acd44cf22ff6c175a795175",
    name: "web_teach_october_mentor_lounge_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_october_mentor_mission_2026_modal: {
    _id: "6ac7ef15bbc225d1061d0bc9",
    name: "web_teach_october_mentor_mission_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_october_monthly_drop_elementary_2026_modal: {
    _id: "6acd44cb389c76f164572cab",
    name: "web_teach_october_monthly_drop_elementary_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_october_monthly_drop_secondary_2026_modal: {
    _id: "6acd44cd22ff6c175a795174",
    name: "web_teach_october_monthly_drop_secondary_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_pcr_nats_realtime: {
    _id: "6a0e59e84c0798b5016b3fcb",
    name: "web_teach_pcr_nats_realtime",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_pd_push_mentors: {
    _id: "6a68fa692b1a9c02b5e29f1b",
    name: "web_teach_pd_push_mentors",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_point_students_idle_animation: {
    _id: "69c5369b976f67228e5afba6",
    name: "web_teach_point_students_idle_animation",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_points_classroom_new_design: {
    _id: "6a29ce01a26eff611c191fa5",
    name: "web_teach_points_classroom_new_design",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_points_report_labels: {
    _id: "69f3e09d6b08864c923f2b08",
    name: "web_teach_points_report_labels",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_quiz_onboarding_v1: {
    _id: "6aa9588abce4908fc2e0eae0",
    name: "web_teach_quiz_onboarding_v1",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["combined", "control", "long_form", "off"],
    defaultValue: "off",
  },
  web_teach_reenable_email_notifications: {
    _id: "69b0b2a4cbbeba891d8acab2",
    name: "web_teach_reenable_email_notifications",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_school_admin_domain_auto_approval_v2: {
    _id: "6a97925ed2f8e6be05386a41",
    name: "web_teach_school_admin_domain_auto_approval_v2",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_school_announcement_ai_sidekick: {
    _id: "6a6cd40eb50e7814868f6fe7",
    name: "web_teach_school_announcement_ai_sidekick",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_school_canva_integration: {
    _id: "697d24ef71b564519da22602",
    name: "web_teach_school_canva_integration",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_school_insights_v2: {
    _id: "6a62783dd941f86ede415726",
    name: "web_teach_school_insights_v2",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_schoolwide_decision_simplified_flow_v2: {
    _id: "6a0c7f4c16166e655ab9972a",
    name: "web_teach_schoolwide_decision_simplified_flow_v2",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["holdout", "off", "rollout", "test"],
    defaultValue: "off",
  },
  web_teach_schoolwide_interest_banner: {
    _id: "69b87070650fcc9707918793",
    name: "web_teach_schoolwide_interest_banner",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["holdout", "off", "rollout", "test"],
    defaultValue: "off",
  },
  web_teach_secondary_mode_no_chat: {
    _id: "6aa05bc107085c7ca8f8c4e1",
    name: "web_teach_secondary_mode_no_chat",
    type: "boolean",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_send_student_login_to_parents_v2: {
    _id: "6ac80258e7b1f221ad31b04d",
    name: "web_teach_send_student_login_to_parents_v2",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_show_send_with_whatsapp_button_v3: {
    _id: "6a2743c0aac1a41693d5f2a0",
    name: "web_teach_show_send_with_whatsapp_button_v3",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test", "test_buttons"],
    defaultValue: "off",
  },
  web_teach_sidekick_live: {
    _id: "6930baadb8f3eb8a7849fa19",
    name: "web_teach_sidekick_live",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sidekick_live_manual_transcript: {
    _id: "69851557e50e2f7bbcf28c0b",
    name: "web_teach_sidekick_live_manual_transcript",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sidekick_live_notes: {
    _id: "69d047f0bcfe4caf1e8d5fb6",
    name: "web_teach_sidekick_live_notes",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_activation_focus_ctas: {
    _id: "6a28904db47fd6bdb08bcb4f",
    name: "web_teach_sl_activation_focus_ctas",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_activation_focus_navigation: {
    _id: "6a275116e7d28f6ab7f05697",
    name: "web_teach_sl_activation_focus_navigation",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_bts_modal_a1: {
    _id: "6a4ecc4757408de0cdba2b72",
    name: "web_teach_sl_bts_modal_a1",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sl_bts_modal_a4: {
    _id: "6a4ecd4957408de0cdba2b73",
    name: "web_teach_sl_bts_modal_a4",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sl_gtm_schoolwide_campaign_for_teachers: {
    _id: "6a0360714da90d735f0ccf36",
    name: "web_teach_sl_gtm_schoolwide_campaign_for_teachers",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sl_nyc_one_on_one_2026_modal: {
    _id: "6aa1b370fc49d8bad9dc2d57",
    name: "web_teach_sl_nyc_one_on_one_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sl_nyc_teacher_pd_2026_modal: {
    _id: "6aa1b372f5867a2799d2b71d",
    name: "web_teach_sl_nyc_teacher_pd_2026_modal",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_teach_sl_onboarding_checklist_post_create_event_v1: {
    _id: "6a727b96f8b96963e28f965d",
    name: "web_teach_sl_onboarding_checklist_post_create_event_v1",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_onboarding_checklist_post_v1: {
    _id: "6a5ef9d89474906b71a1d7dd",
    name: "web_teach_sl_onboarding_checklist_post_v1",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_onboarding_checklist_pre_v1: {
    _id: "6a4536682f78b61bfb8e22dd",
    name: "web_teach_sl_onboarding_checklist_pre_v1",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_sl_onboarding_checklist_pre_verify_cx_v1: {
    _id: "6a7e92a2b85d1d27761189dc",
    name: "web_teach_sl_onboarding_checklist_pre_verify_cx_v1",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_slgtm_modal_banner_teach_2026_holdout: {
    _id: "6a10999d7862efb5d6492181",
    name: "web_teach_slgtm_modal_banner_teach_2026_holdout",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["holdout", "off", "rollout", "test"],
    defaultValue: "off",
  },
  web_teach_sso_signup_option_v4: {
    _id: "6a21a531880bd686556b7d7c",
    name: "web_teach_sso_signup_option_v4",
    type: "multivariate",
    audienceTypes: ["session"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_student_connection_stage_tracker_experiment: {
    _id: "6ac658642632a7f5ce6e27d1",
    name: "web_teach_student_connection_stage_tracker_experiment",
    type: "multivariate",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_student_story_feed_settings: {
    _id: "6a4573d08d5c16ff7f631f2a",
    name: "web_teach_student_story_feed_settings",
    type: "multivariate",
    audienceTypes: ["school"],
    apps: ["teach"],
    variants: ["control", "off", "test"],
    defaultValue: "off",
  },
  web_teach_use_new_api_for_nats_award: {
    _id: "69f5030d906580c08fe91027",
    name: "web_teach_use_new_api_for_nats_award",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
  web_tps_messaging_consent_invitation_flow: {
    _id: "6a2c4a741f6f0856eb682ae9",
    name: "web_tps_messaging_consent_invitation_flow",
    type: "boolean",
    audienceTypes: ["teacher"],
    apps: ["teach"],
    variants: ["off", "on"],
    defaultValue: "off",
  },
} as const;

// ────────────────────────────────────────────────────────────
// Derived types
// ────────────────────────────────────────────────────────────

type ArrayToUnion<T extends readonly string[]> = T[number];

type Registry = typeof FeatureSwitchRegistry;

export type FeatureSwitchDef = {
  [K in keyof Registry]: {
    name: K;
    type: Registry[K]["type"];
    audienceTypes: Registry[K]["audienceTypes"];
    variants: ArrayToUnion<Registry[K]["variants"]>;
    defaultValue: Registry[K]["defaultValue"];
  };
}[keyof Registry];

export type FeatureSwitchName = FeatureSwitchDef["name"];

export type FeatureSwitchNameAndVariant = {
  [F in FeatureSwitchDef as F["name"]]: F["variants"];
};

export type FeatureSwitchVariants<TName extends FeatureSwitchName> = FeatureSwitchNameAndVariant[TName];

export type FeatureSwitchVariantArray<TName extends FeatureSwitchName> = FeatureSwitchVariants<TName>[];

/** Feature switches that can be started as experiments (excludes holdout switches). */
export type StartableExperiment = Exclude<FeatureSwitchName, `holdout_${string}`>;

/** All audience types present in the registry. */
export type AudienceType = ArrayToUnion<Registry[keyof Registry]["audienceTypes"]>;

/** All app names present in the registry. */
export type AppName = ArrayToUnion<Registry[keyof Registry]["apps"]>;
